module.exports = __webpack_public_path__ + "static/media/speaker_WSP_WanAlexChiNga.1b369744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_WSP_WanAlexChiNga.jpg
// module id = 260
// module chunks = 0